<template>
    <template v-if="routeObj">
        <pendo-router-link
            class="notification-link"
            :to="routeObj"
            @keydown.enter.space.prevent="$emit('cardClicked', $attrs.id)"
            @click="$emit('cardClicked', $attrs.id)">
            <base-notification-card
                v-bind="$attrs">
                <template #content>
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        class="body"
                        v-html="sanitizedBody" />
                <!-- eslint-enable vue/no-v-html -->
                </template>
            </base-notification-card>
        </pendo-router-link>
    </template>
    <template v-else>
        <base-notification-card
            v-bind="$attrs"
            @card-clicked="$emit('cardClicked', $attrs.id)">
            <template #content>
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="body"
                    v-html="sanitizedBody" />
                <!-- eslint-enable vue/no-v-html -->
            </template>
        </base-notification-card>
    </template>
</template>

<script>
import BaseNotificationCard from './base-notification-card.vue';
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';

export default {
    name: 'CommentNotificationCard',
    components: {
        PendoRouterLink,
        BaseNotificationCard,
    },
    inheritAttrs: false,
    props: {
        routeObj: {
            type: Object,
            default: null,
        },
    },
    emits: ['cardClicked'],
    computed: {
        sanitizedBody () {
            return this.$sanitize(this.$attrs.body);
        },
    },
};
</script>

<style scoped lang="less">
.notification-link:hover {
    text-decoration: none;
}

.notification-card {
    .body {
        grid-column-start: 2;
        grid-column-end: 3;
        color: var(--palette-gray-70);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
}
</style>
